import { Container } from '@hover/blueprint';
import React from 'react';
import ProductionMobile from './ProductionMobile';
import ProductionDesktop from './ProductionDesktop';

const REAL_TIME_LIST_ITEMS = [
  'Accurate estimates for multiple trades',
  'Dependable materials list',
  'Supplier-direct ordering with zero manual entry',
];

const ORDER_DIRECTLY_LIST_ITEMS = [
  'Labor lists for multiple trades',
  'Pre-populated work orders',
  'Keep work on-site on-track',
];

const ExteriorContractorsProduction = () => (
  <Container maxW="1200px" px={500} pb={{ base: 0, desktop: 1100 }}>
    <ProductionMobile
      orderDirectlyListItems={ORDER_DIRECTLY_LIST_ITEMS}
      realTimeListItems={REAL_TIME_LIST_ITEMS}
    />
    <ProductionDesktop
      orderDirectlyListItems={ORDER_DIRECTLY_LIST_ITEMS}
      realTimeListItems={REAL_TIME_LIST_ITEMS}
    />
  </Container>
);

export default ExteriorContractorsProduction;
